module.exports = __webpack_public_path__ + "static/BrandonGrotesque-RegularItalic-d4599bce3aa6325950ae09b8e7583f7d.woff2";